import type { Translations } from './en.js';

const ko: Translations = {
  ok: '확인',
  cancel: '취소',
  close: '닫기',
  confirm: '확인',
  language: '언어',

  game_title: '검 강화하기',
  tap_to_start: '터치하여 시작',
  title_load_failed: '타이틀 이미지 로드 실패:',
  game_started: '검 강화하기 게임 시작!',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 올 클리어!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (무료!)',

  btn_enhance: '⚒️ 강화',
  btn_enhance_ready: '⚔️ 강화',
  btn_enhance_complete: '🏆 완료',
  btn_free_enhance: '▶ 무료 강화',
  btn_exhausted: '소진',
  btn_boost: '확률\nUP',
  btn_applying: '적용\n중!',
  btn_protection_active: '🛡️ 보호 활성화됨',
  btn_protection_use: '🛡️ 방지권 사용',
  btn_sell: '💰 판매',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 상점',
  cost_max: 'MAX',
  cost_free: '0 G (무료!)',

  tab_settings: '⚙️ 설정',
  tab_inventory: '📦 인벤토리',
  bgm_on: '🎵 배경음악 ON',
  bgm_off: '🎵 배경음악 OFF',
  sfx_on: '🔊 효과음 ON',
  sfx_off: '🔊 효과음 OFF',
  inventory_title: '⚔️ 보관된 무기',
  inventory_empty: '보관된 무기가 없습니다',
  equip: '장착',
  equip_msg: '{name} 장착!',
  reset_confirm_title: '⚠️ 정말 초기화할까요?',
  reset_confirm_desc: '모든 진행 상황이 삭제됩니다',
  reset: '초기화',
  reset_start_over: '🔄 처음부터 다시 시작',
  menu_close: '닫기',

  inv_scrolls_title: '방지권 보유',
  inv_scrolls_line1: '초급: {c0}  |  중급: {c1}',
  inv_scrolls_line2: '고급: {c2}  |  초고급: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: '광고 보고 무료 강화',
  ad_gold_desc: '강화 비용 1회 0원',
  ad_gold_note: '(방지권, 확률UP 적용됨)',
  ad_gold_confirm: '▶ 광고 시청',
  ad_gold_free_next: '다음 강화 무료!',
  ad_gold_exhausted: '사용 횟수 소진!',
  ad_gold_remaining: '남은 횟수: {current}/3',

  boost_popup_title: '📺 광고 시청',
  boost_confirm: '▶ 광고 보고 적용',
  boost_close: '닫기',
  boost_applied: '확률 UP 적용!',
  boost_already_applied: '이미 적용 중!',
  boost_exhausted: '사용 횟수 소진!',
  boost_remaining: '🎬 남은 사용 횟수: {current}/3',
  boost_popup_desc: '현재 {rate}% → {mult} 적용',
  boost_rate_display: '{rate}%',
  boost_mult_2x: '2배',
  boost_mult_1_5x: '1.5배',
  boost_mult_1_3x: '1.3배',

  protection_popup_title: '방지권 사용',
  protection_use: '사용하기',
  protection_cancel: '취소',
  protection_popup_info:
    '현재 레벨: Lv.{level}\n필요: {name} 1개\n보유 중: {count}개',
  protection_activated: '{name} 활성화!',
  protection_returned: '{name} 반환됨',
  protection_protected: '방지권으로 보호됨!',

  msg_max_level: '이미 최고 레벨입니다!',
  msg_gold_short: '골드 부족!',
  msg_success_boost: '부스트 강화 성공!',
  msg_success: '강화 성공!',
  msg_destroyed: '파괴!',

  shop_title: '상점',
  tab_protection: '보호 주문서',
  tab_weapons: '무기 구매',
  weapon_shop_title: '⚔️ 무기 구매',
  item_free: '무료',
  close_shop: '닫기',
  buy_complete_title: '구매 완료!',
  buy_complete_desc: '구매한 아이템은\n상단 ⚙️ 설정 → 📦 인벤토리에서\n확인할 수 있습니다!',
  buy_complete_ok: '확인',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} 획득!',
  weapon_moved_to_inventory: '{name} → 인벤토리',
  price_display: '{amount}G',
  sell_received: '{amount}G 획득!',

  destroy_title: '무기가 파괴되었습니다',
  destroy_ad_restore: '광고 보고 복구하기',
  destroy_restore_ad: '광고 보고 복구하기 ({current}/{max})',
  destroy_give_up: '처음부터 다시 시작',
  destroy_restore_count: '남은 복구 기회: {current}/{max}',
  destroy_restored: 'Lv.{level} 무기 복구 완료!',
  ad_watch_fail: '광고 시청 실패',
  weapon_restored: '{name} 복구 완료!',

  completion_title: '최강의 검을 완성했습니다!',
  completion_all_done: '🏆 모든 강화 완료! 🏆',
  congrats_text: '🎉 축하합니다! 🎉',
  register_name: '✏️ 이름 등록하기',
  prompt_register_name: '명예의 전당에 등록할 이름을 입력하세요:',
  no_completion: '아직 완료자가 없습니다',
  be_first: '첫 번째 완료자가 되세요!',
  completion_close: '닫기',
  leaderboard_title: '📋 명예의 전당',
  leaderboard_entry: '{rank}위 - {name}',
  completion_rank_msg: '당신은 {rank}번째 완료자입니다!',
  completion_total_msg: '지금까지 {total}명이 완료했습니다',

  weapon_image_load_failed: '무기 이미지 로드 실패:',

  weapon_0: '맨손',
  weapon_1: '그냥 단검',
  weapon_2: '쇠검',
  weapon_3: '은검',
  weapon_4: '스노우보드 검',
  weapon_5: '웨이브 검',
  weapon_6: '마법 소녀 검',
  weapon_7: '곰 검',
  weapon_8: '불타는 해골 검',
  weapon_9: '번개 검',
  weapon_10: '달빛 단검',
  weapon_11: '드래곤 소드',
  weapon_12: '근육 검',
  weapon_13: '왕다이아검',
  weapon_14: '청룡언월도',
  weapon_15: '고대의 검',
  weapon_16: '해적왕 쌍수검',
  weapon_17: '두바이쫀득 검',
  weapon_18: '칠칠도',
  weapon_19: '마법소녀 지팡이 검',
  weapon_20: '위잉위잉검',
  weapon_21: '팔레트 검',
  weapon_22: '대자연의 검',
  weapon_23: '사이보그 검',
  weapon_24: '블랙홀 검',
  weapon_25: '골든버드검',
  weapon_26: '크리스탈파워 검',
  weapon_27: '다크 드래곤 검',
  weapon_28: '집게발 검',
  weapon_29: 'AI 검',
  weapon_30: '체인소우 검',
  weapon_31: '별똥별의 힘 검',
  weapon_32: '다크다크 검',
  weapon_33: '갤럭시 검',
  weapon_34: '진짜 비싼 다이아 검',

  scroll_basic: '초급 방지권',
  scroll_mid: '중급 방지권',
  scroll_hi: '고급 방지권',
  scroll_ultra: '초고급 방지권',
  scroll_label_basic: '초급',
  scroll_label_mid: '중급',
  scroll_label_hi: '고급',
  scroll_label_ultra: '초고급',

  // === Materials (Sprint 1) ===
  mat_iron_dust: '무쇠 가루',
  mat_refining_core: '정련의 핵',
  mat_lava_essence: '용암정수',
  mat_abyss_crystal: '심연결정',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: '재료 획득!',
  mat_double_ad: '광고 보고 2배',
  mat_doubled: '2배 적용!',
  mat_panel_title: '재료',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: '보관',
  keep_full: '보관함 가득!',
  keep_lv1_blocked: 'Lv.1 무기는 보관할 수 없습니다',
  keep_success: '{name} 보관됨!',
  keep_retrieve: '장착',
  keep_sell: '판매',
  keep_slot_expand: '슬롯 확장',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: '슬롯: {used}/{total}',
  keep_panel_title: '보관된 무기',
  keep_empty: '보관된 무기 없음',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: '슬롯을 확장하세요!',

  // === 용광로 (Sprint 2) ===
  tab_forge: '용광로',
  forge_title: '용광로',
  forge_tab_weapon: '무기',
  forge_tab_scroll: '방지권',
  forge_tab_upgrade: '재료 승급',
  forge_craft_btn: '제작',
  forge_craft_success: '{name} 제작 완료!',
  forge_not_enough_mat: '재료 부족',
  forge_weapon_to_equip: '바로 장착할까요?',
  forge_weapon_to_keep: '보관',
  forge_weapon_equip: '장착',
  forge_keep_full_equip: '보관함 가득 — 바로 장착합니다.',
  forge_cost_label: '비용:',
  forge_result_label: '결과:',

  forge_recipe_weapon_lv5: 'Lv.5 무기 제작',
  forge_recipe_weapon_lv10: 'Lv.10 무기 제작',
  forge_recipe_weapon_lv15: 'Lv.15 무기 제작',
  forge_recipe_weapon_lv21: 'Lv.21 무기 제작 (피티)',
  forge_recipe_weapon_lv21_desc: '강화 없이 Lv.21 무기 바로 획득! (실패 걱정 없음)',
  forge_recipe_scroll_basic: '초급 방지권 제작',
  forge_recipe_scroll_mid: '중급 방지권 제작',
  forge_recipe_scroll_hi: '고급 방지권 제작',
  forge_recipe_scroll_ultra: '초고급 방지권 제작',
  forge_recipe_upgrade_1: '무쇠 가루 → 정련의 핵',
  forge_recipe_upgrade_2: '정련의 핵 → 용암정수',
  forge_recipe_upgrade_3: '용암정수 → 심연결정',

  scroll_effect_basic: 'Lv.1-9 강화 실패 시 파괴 방지',
  scroll_effect_mid: 'Lv.10-19 강화 실패 시 파괴 방지',
  scroll_effect_hi: 'Lv.20-24 강화 실패 시 파괴 방지',
  scroll_effect_ultra: 'Lv.25-34 강화 실패 시 파괴 방지',
  scroll_buy_btn: '구매',

  keep_card_equip: '장착',
  keep_card_sell: '판매',
  keep_slot_empty: '비어있음',

  // === Sacrifice System (Sprint 3) ===
  sacrifice_btn: '무기 제물',
  sacrifice_panel_title: '무기 제물 바치기',
  sacrifice_panel_desc: 'Lv.{level} 무기를 제물로 바치면 성공률이 1개당 +{tierPct}% 증가',
  sacrifice_empty: '보관함에 Lv.{level} 무기 없음',
  sacrifice_bonus_label: '보너스: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: '바치기',
  sacrifice_ad_slots: '광고 보고 성공률 +{pct}%',
  sacrifice_ad_exhausted: '광고 한도 초과',
  sacrifice_ad_granted: '제물 +3 추가됨!',
  sacrifice_added: '제물 수락! +{tierPct}% 보너스',
  sacrifice_cap_reached: '제물 한도 초과',
  sacrifice_reset: '제물 보너스 초기화',

  // === Infinity Mode (Sprint 3) ===
  infinity_btn: '인피니티',
  infinity_active: '무료 {sec}초',
  infinity_popup_title: '인피니티 모드',
  infinity_popup_desc: '10초 동안 골드 없이 마음껏 강화!\n성공 확률은 평소와 같아요 — 실패하면 파괴될 수 있어요!',
  infinity_popup_confirm: '광고 시청',
  infinity_popup_close: '닫기',
  infinity_cooldown: '{sec}초 후 사용가능',
  infinity_daily_exhausted: '일일 한도 초과',
  infinity_started: '인피니티 모드 ON! 10초간 무료',
  infinity_ended: '인피니티 모드 종료',

  // === Buff Items (Sprint 3) ===
  buff_item_luck_charm: '행운부적',
  buff_item_guarantee: '보장강화권',
  buff_item_destroy_guard: '파괴방지권',
  buff_item_use: '사용',
  buff_item_active: '활성',
  buff_item_empty: '0',
  buff_luck_charm_activated: '행운부적 활성! 다음 강화 +5%',
  buff_guarantee_activated: '보장강화권 활성! 다음 강화 100%',
  buff_destroy_guard_activated: '파괴방지권 활성! 다음 실패 파괴 안됨',
  buff_luck_charm_consumed: '행운부적 소모됨',
  buff_guarantee_consumed: '보장강화권 소모됨',
  buff_destroy_guard_consumed: '파괴방지권 소모 — 파괴 차단!',
  buff_item_already_active: '이미 활성화됨!',
  buff_item_none: '{name} 없음',
  buff_popup_count: '보유: {count}개',
  buff_popup_use_btn: '사용하기',
  buff_popup_no_stock: '보유 없음. 용광로에서 제작하세요.',
  buff_popup_luck_charm_effect: '다음 강화 성공률 +5% 증가',
  buff_popup_guarantee_effect: '다음 강화 1회 100% 성공 보장',
  buff_popup_destroy_guard_effect: '다음 강화 실패 시 무기 파괴를 막아줍니다 (1회)',

  // === Forge Item Recipes (Sprint 3) ===
  forge_recipe_item_luck_charm: '행운부적 제작',
  forge_recipe_item_luck_charm_desc: '다음 강화 성공률 +5%',
  forge_recipe_item_guarantee: '보장강화권 제작',
  forge_recipe_item_guarantee_desc: '다음 강화 100% 성공',
  forge_recipe_item_destroy_guard: '파괴방지권 제작',
  forge_recipe_item_destroy_guard_desc: '다음 실패 시 파괴 방지',
  forge_tab_item: '아이템',
};

export default ko;
